<template>
    <div>
        <div class="row mb-2">
            <div class="col-sm-4">
                <router-link :to="{ name: 'PartnerAdd' }" class="btn btn-danger btn-rounded mb-3">
                    <i class="mdi mdi-plus"></i> Добавить партнера
                </router-link>
            </div>
        </div>

        <div class="row" v-if="items === null">
            <div class="col-md-12 text-center">
                <div class="spinner-grow" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <div class="row" v-else>
            <table class="table table-striped table-centered  table-responsive-md mb-0">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Лого</th>
                        <th>Название</th>
                        <th>Закреплен на главной</th>
                        <th>Показан</th>
                        <th>Удален</th>
                        <th>Дата создания</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in filteredItems" :key="i">
                        <td>{{ item._id }}</td>
                        <td>
                            <img :src="getCDNUrl(item.logo.path)" v-if="item.logo && item.logo.path" class="img-fluid"
                                style="max-width:200px; max-height: 100px">
                        </td>
                        <td>{{ item.name }}</td>
                        <td>
                            <div class="badge" :class="item.pinned ? 'badge-success' : 'badge-secondary'">
                                <span v-if="item.pinned">Закреплен</span>
                                <span v-else>Не закреплен</span>
                            </div>
                        </td>
                        <td>
                            <div class="badge" :class="item.show ? 'badge-success' : 'badge-secondary'">
                                <span v-if="item.show">Показан на сайте</span>
                                <span v-else>Скрыт</span>
                            </div>
                        </td>
                        <td>
                            <div class="badge" :class="item.deleted ? 'badge-danger' : 'badge-secondary'">
                                <span v-if="item.deleted">Удален</span>
                                <span v-else>Нет</span>
                            </div>
                        </td>
                        <td>{{ formatDate(item.created) }}</td>
                        <td>
                            <router-link class="btn btn-sm btn-rounded btn-info"
                                :to="{ name: 'PartnerEdit', params: { id: item._id } }">редактировать</router-link>

                            <button v-if="!item.pinned" class="btn btn-sm btn-rounded btn-info ml-1"
                                @click.prevent="pinItem(item._id, true)"><i class="mdi mdi-pin mr-1"></i>Закрепить на
                                главной</button>
                            <button v-else class="btn btn-sm btn-rounded btn-info ml-1"
                                @click.prevent="pinItem(item._id, false)"><i class="mdi mdi-pin-off mr-1"></i>Убрать с
                                главной</button>

                            <button v-if="item.deleted" class="btn btn-sm btn-rounded btn-warning ml-1"
                                @click="restoreItem(item._id)">восстановить</button>
                            <button v-else class="btn btn-sm btn-rounded btn-danger ml-1"
                                @click="deleteItem(item._id)">удалить</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import log from '@/plugins/log'
import { to } from '@/plugins/utils'
import * as dayjs from 'dayjs'

import localizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/ru'

dayjs.extend(localizedFormat)
dayjs.locale('ru')

export default {
    name: 'PartnerList',
    data: () => {
        return {
            items: null,
            filter: {
                deleted: false
            }
        }
    },
    computed: {
        ...mapState([
            'app_cdn_host'
        ]),
        filteredItems() {
            return this.items.filter(item => {
                //if(this.filter.deleted === false && item.deleted) return false

                return true
            })
        }
    },
    beforeMount() {
        this.getData()
    },
    mounted() {
        log.debug('/views/partner/list', 'mounted')
    },
    methods: {
        async getData() {
            var [err, response] = await to(this.$http.get('/partner/list'))
            if (err) {
                log.error('/views/partner/list', 'methods.getData', '$http.request', err)
                return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
            }
            log.debug('/views/partner/list', 'methods.getData', '$http.request', response.data)

            this.items = response.data.items
        },
        async deleteItem(id) {
            if (!confirm('Уверены, что хотите удалить?')) return;

            var [err, response] = await to(this.$http.post(`/partner/delete/${id}`))
            if (err) {
                log.error('/views/partner/list', 'methods.deleteItem', '$http.request', err)
                return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
            }
            if (!response.data.success) {
                log.error('/views/partner/list', 'methods.deleteItem', '$http.response', response.data)
                return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
            }
            log.debug('/views/partner/list', 'methods.deleteItem', '$http.request', response.data)

            this.getData()
        },
        async pinItem(id, status) {
            var [err, response] = await to(this.$http.post(`/partner/edit/${id}`, { pinned: !!status }))
            if (err) {
                log.error('/views/partner/list', 'methods.pinItem', '$http.request', err)
                return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
            }
            if (!response.data.success) {
                log.error('/views/partner/list', 'methods.pinItem', '$http.response', response.data)
                return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
            }
            log.debug('/views/partner/list', 'methods.pinItem', '$http.request', response.data)

            this.getData()
        },
        async restoreItem(id) {
            var [err, response] = await to(this.$http.post(`/partner/restore/${id}`))
            if (err) {
                log.error('/views/partner/list', 'methods.restoreItem', '$http.request', err)
                return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
            }
            if (!response.data.success) {
                log.error('/views/partner/list', 'methods.restoreItem', '$http.response', response.data)
                return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
            }
            log.debug('/views/partner/list', 'methods.restoreItem', '$http.request', response.data)

            this.getData()
        },

        formatDate(date) {
            return dayjs(date).format('LL')
        },

        getCDNUrl(path, modify = []) {
            let modification_string = modify.length ? modify.join(',') + '/_/' : ''
            return `${this.app_cdn_host}/i/${modification_string}${path}`
        }
    }
};
</script>